import { render, staticRenderFns } from "./membership-category.vue?vue&type=template&id=92432220&"
import script from "./membership-category.vue?vue&type=script&lang=ts&"
export * from "./membership-category.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports